import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Header from './cognitoHeader';
import Box from '@mui/material/Box';
import ShopItem from './ShopItem';

const theme = createTheme();

export default function Shop() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Container maxWidth="md">
                <Header title="Rocket Electronics" sections={[]} />
                <main>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Box sx={{
                            borderRadius: "10px",
                            width: "100%",
                            height: {
                                xs: "20vh",
                                lg: "40vh"
                            },
                            marginBottom: "20px",
                        }} component="img" src="/rocket-electronics.png" />
                    </div>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <ShopItem
                                name="Lenovo DGX"
                                price="$649"
                                text="The best laptop for home use"
                                image="/laptop-1.webp"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <ShopItem
                                name="Nikon Blu"
                                price="$399"
                                text="The best camera to capture cats"
                                image="/camera-2.webp"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <ShopItem
                                name="Macbook Pro"
                                price="$9999"
                                text="The all-time favorite has arrived!"
                                image="/macbook-1.webp"
                            />
                        </Grid>
                    </Grid>
                </main>
            </Container>
        </ThemeProvider>
    );
}
